module.exports = __webpack_public_path__ + "static/media/faza1_AL.6e1d3371.svg";